<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M3.25 9.25H16.75V14.5C16.75 15.3284 16.0784 16 15.25 16H4.75C3.92157 16 3.25 15.3284 3.25 14.5V9.25Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.75 9.25V4C10.75 3.58579 11.0858 3.25 11.5 3.25H14.5C14.9142 3.25 15.25 3.58579 15.25 4V9.25" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.7529 6.25H12.2529" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.75293 9.25V5.65117C4.75293 5.31057 4.86885 4.9801 5.08162 4.71413L6.01867 3.54282C6.16673 3.35774 6.39091 3.25 6.62793 3.25C6.86495 3.25 7.08912 3.35774 7.23718 3.54282L8.17423 4.71413C8.387 4.9801 8.50292 5.31057 8.50292 5.65117V9.25" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'AgencyDirectorySettingsIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>